import React, { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../../../../../../../../shadcn/components/ui/button'
import { Icon, SimpleModal } from '../../../../../../../../atoms'
import { BigCalendarProps } from '../../../BigCalendar'

export type BigCalendarHeaderICalendarExportProps = {
  house: Pick<BigCalendarProps['house'], 'iCalURL'>
}
export const BigCalendarHeaderICalendarExport = ({
  house: { iCalURL },
}: BigCalendarHeaderICalendarExportProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const [isUrlCopied, setIsUrlCopied] = useState(false)

  const handleOnCopy = () => {
    setIsUrlCopied(true)

    setTimeout(() => {
      setIsUrlCopied(false)
    }, 2000)
  }

  const handleOnOpen = () => {
    setIsOpen(true)
  }

  const handleOnClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      {iCalURL ? (
        <>
          <Button onClick={handleOnOpen}>
            <div className='flex items-center gap-2'>
              <span>
                <FormattedMessage
                  defaultMessage='Exporter iCal'
                  id='ui.BigCalendarHeaderICalendarExport.exportICal'
                />
              </span>
              <Icon name='upload' size={22} />
            </div>
          </Button>

          <SimpleModal
            hasError={false}
            isLoading={false}
            name='big-calendar-icalendar-export-modal'
            isOpen={isOpen}
            onClose={handleOnClose}
            style={{ height: '40vh', width: '50vw' }}
            content={{
              body: (
                <div className='flex h-full flex-col justify-center gap-8 overflow-scroll p-8'>
                  <div className='text-grey-700'>
                    <FormattedMessage
                      defaultMessage='Si vous souhaitez exporter votre calendrier Naboo sur un calendrier externe, copiez le lien ci-dessous'
                      id='ui.BigCalendarHeaderICalendarExport.copyUrl'
                    />
                  </div>

                  <CopyToClipboard text={iCalURL ?? ''} onCopy={handleOnCopy}>
                    <Button
                      disabled={isUrlCopied}
                      className='flex w-full gap-2 overflow-hidden rounded-[6px] bg-primary-400 p-4'
                    >
                      <span className='overflow-hidden truncate'>
                        {iCalURL}
                      </span>

                      {isUrlCopied ? (
                        <Icon name='check-circle-outline' size={22} />
                      ) : (
                        <Icon name='copy' size={22} />
                      )}
                    </Button>
                  </CopyToClipboard>
                </div>
              ),
              footer: null,
              header: (
                <div className='font-bold'>
                  <FormattedMessage
                    defaultMessage='Synchronisez vos calendriers externes avec Naboo'
                    id='ui.BigCalendarHeaderICalendarExport.syncWithExternalCalendars'
                  />
                </div>
              ),
            }}
          />
        </>
      ) : null}
    </>
  )
}
